
/**
* @class
* @description Module which provides device manager and monitoring capabilities
**/
export default  class DeviceManager{

    /** 
     * @method EnableAppCommunication Enable user to listen realtime data
     */
    EnableAppCommunication(){
        throw "Not implemented"
    }

    /** 
     * @method StartListenDevicesActivity Start listening device activity
     */
    StartListenDeviceActivity(){
        throw "Not implemented"
    }

    /** 
     * @method StopListenDeviceActivity Stop listening device activity
     */
    StopListenDeviceActivity(){
        throw "Not implemented"
    }

    /** 
     * @method Control Control device
     * @param {Object} device New device model
     */
    RegisterDevice(){
        throw "Not implemented"
    }

    /** 
     * @method Control Claim child device
     */
    ClaimSlaveDevice(){
        throw "Not implemented"
    }

    /**
     * @method ListDevices List devices of user currentely logged
     */
    ListDevices(){
        throw "Not implemented"
    } 
    
    /** 
     * @method UpdateConfiguration Update device configuration
     * @param {String} deviceId Device id
     * @param {String} gatewayId Gateway id
     * @param {Object} configuration Updated device configuration
     */
    UpdateConfiguration(){
        throw "Not implemented"
    }

    /** 
     * @method Control Control device
     * @param {String} deviceId Device id
     * @param {String} gatewayId Gateway id
     * @param {Object} payload Payload
     */
    Control(){
        throw "Not implemented"
    }

    /** 
     * @method Fota Start FOTA on device
     * @param {String} deviceId Device id
     * @param {String} gatewayId Gateway id
     * @param {Object} firmware firmware object
     */
    Fota(){
        throw "Not implemented"
    }

    /** 
     * @method SelectAIAlgorithm Start selecting AI firmware on device
     * @param {String} deviceId Device id
     * @param {String} gatewayId Gateway id
     * @param {Object} algorithm algorithm object
     */
    SelectAIAlgorithm(){
        throw "Not implemented"
    }

    /** 
     * @method DeleteDevice Delete a device
     * @param {String} deviceId Device id
     */
    DeleteDevice(){
        throw "Not implemented"
    }

    /**
     * @method ListFirmwares List firmwares of user currentely logged
     */
    ListFirmwares(){
        throw "Not implemented"
    } 

    /**
     * @method UploadFirmware Upload firmware for user currentely logged
     * @param {Firmware} firmware Firmware model
     */
    UploadFirmware(){
        throw "Not implemented"
    } 

    /**
     * @method RemoveFirmware Upload firmware for user currentely logged
     * @param {Array} firmwaresName Firmware name to remove from cloud
     */
    RemoveFirmwares(){
        throw "Not implemented"
    } 

    /**
     * @method GeneratPartialFirmware Generate partial firmware with updated weights starting from a model
     * @param {object} model Model
     */
    GeneratePartialFirmware(){
        throw "Not implemented"
    }

    /**
     * @method ListApiKeys List API keys 
     */
    ListApiKeys(){
        throw "Not implemented"
    }

    /**
     * @method CreateApiKey Create API key needs to enable uplink device generic communication
     * @param {object} model Model
     */
    CreateApiKey(){
        throw "Not implemented"
    }

    /**
     * @method UpdateApiKey Update API key
     * @param {object} model Model
     */
    UpdateApiKey(){
        throw "Not implemented"
    }

    /**
     * @method DeleteApiKey Delete API key needs 
     * @param {object} model Model
     */
    DeleteApiKey(){
        throw "Not implemented"
    }

    /**
     * @method ListDeviceProfiles List device profiles
     */
    ListDeviceProfiles(){
        throw "Not implemented"
    }

    /**
     * @method CreateDeviceProfile Create device profile
     * @param {object} model Model
     */
    CreateDeviceProfile(){
        throw "Not implemented"
    }

    /**
     * @method DeleteDeviceProfile Delete device profile
     * @param {object} model Model
     */
    DeleteDeviceProfile(){
        throw "Not implemented"
    }

    /**
     * @method GetTelemetry Get telemetry of devices
     * @param {Array<string>} deviceIds Device ids
     * @param {Date} startTimestamp Start timestamp window
     * @param {Date} endTimestamp End timestamp window
    */
    GetTelemetry(){}

    /**
     * @method GetGeolocation Get geo location of devices
     * @param {Array<string>} deviceIds Device ids
     * @param {Date} startTimestamp Start timestamp window
     * @param {Date} endTimestamp End timestamp window
    */
    GetGeoLocations(){}

    /** 
     * @method CreatePerimeter Create a geofence perimeter for selected devices
     * @param {Array<string>} deviceIds Device ids
     * @param {String} perimeter Devices' geofence perimeter
     */
    CreatePerimeter(){
        throw "Not implemented"
    }

    /** 
     * @method FetchPerimeters Get a geofence perimeter for selected devices
     * @param {Array<string>} deviceIds Device ids
     * @param {String} perimeter Devices' geofence perimeter
     */
    FetchPerimeters(){
        throw "Not implemented"
    }

    /**
     * @method GetEvents Get events of devices
     * @param {Array<string>} deviceIds Device ids
     * @param {Date} startTimestamp Start timestamp window
     * @param {Date} endTimestamp End timestamp window
    */
   GetEvents(){}
}